// components/MobileCart.jsx - Functional Mobile Layout
import React from 'react';
import ProductDisplay from './ProductDisplay';
import OrderSummary from './OrderSummary';

const MobileCart = ({ displayProducts, user, gold, translate, currentView, setCurrentView, deleteFromCart, deleteThisProductId, cart_items, cart_credit }) => {
  return (
    <div className='marketplace-mobile-layout'>
      {/* <div className='marketplace-mobile-tabs'>
        <button className={`marketplace-tab-btn ${currentView === 'main' ? 'marketplace-tab-active' : ''}`} onClick={() => setCurrentView('main')}>
          سبد خرید
        </button>
        <button className={`marketplace-tab-btn ${currentView === 'sidebar' ? 'marketplace-tab-active' : ''}`} onClick={() => setCurrentView('sidebar')}>
          جزئیات سفارش
        </button>
      </div> */}

      <div className='marketplace-mobile-content'>
        <div className='marketplace-mobile-cart'>
          <div className='marketplace-cart-title'>سبد خرید شما</div>
          <ProductDisplay displayProducts={displayProducts} user={user} gold={gold} translate={translate} onDelete={deleteFromCart} deleteThisProductId={deleteThisProductId} />
        </div>

        {Object.keys(user).length > 0 && (
          <div className='marketplace-mobile-info'>
            <OrderSummary user={user} translate={translate} cart_items={cart_items} cart_credit={cart_credit} />
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileCart;
